import { Component, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';

declare global {
  interface Window {
    myWidgetConfig?: any;
    egaAccessibilityWidget?: any;
  }
}

@Component({
  selector: 'app-accessibility',
  standalone: true,
  templateUrl: './accessibility.component.html',
  styleUrl: './accessibility.component.scss',
})
export class AccessibilityComponent implements AfterViewInit, OnDestroy {
  isLoading = true;
  private checkInterval: any;
  private timeoutHandle: any;

  @ViewChild('widgetContainer') widgetContainer!: ElementRef<HTMLDivElement>;

  ngAfterViewInit(): void {
    window.myWidgetConfig = {
      integration: { targetSelector: '#angular-widget-container' },
    };

    if (window.egaAccessibilityWidget) {
      this.initWidget();
    } else {
      this.checkInterval = setInterval(() => {
        if (window.egaAccessibilityWidget) {
          clearInterval(this.checkInterval);
          this.initWidget();
        }
      }, 100);

      this.timeoutHandle = setTimeout(() => {
        if (this.isLoading) {
          clearInterval(this.checkInterval);
          this.isLoading = false;
        }
      }, 10000);
    }
  }

  private initWidget(): void {
    window.egaAccessibilityWidget.init(window.myWidgetConfig);

    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

  ngOnDestroy(): void {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
    }
  }
}
